@if (ondOffers().length > 0) {
  <div class="mr-large-y">
    @if (heading(); as heading) {
      <h2 class="mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
        {{ heading }}
      </h2>
    }

    @if (sortOptions().length) {
      @let options = sortOptions();
      <div class="fill align-right mr-small-b">
        <select
          class="nordic-blue-900-text text-icon-primary medium-type focus-inset"
          name="selectedSortBy"
          [value]="sortBy()"
          (change)="sortOffers($any($event.target).value)"
        >
          @for (option of options; track option.value) {
            <option [value]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>
    }

    <div class="ms-xxsmall-t">
      @for (ondOffer of ondOffers() | slice: 0 : offerAmount(); track $index; let i = $index) {
        <div
          class="offer-list-item flex border rounded grey-50-bg surface-disabled-bg pr-xsmall mr-xxsmall-b animate-appear ond-list-item"
          [ngClass]="
            i + 1 > offerAmount() - moreOffersAmount && !dynamicAnimationDisabled()
              ? 'animate-appear--' + (i - offerAmount() + moreOffersAmount)
              : ''
          "
        >
          <div class="flex-1 flex--basis0 flex--self-center pr-medium-r">
            <div class="light-type font-body-1 ms-xxsmall-b font-body-medium" data-testid="offer-list-location-codes">
              {{ ondOffer?.originLocationCode }} – {{ ondOffer?.destinationLocationCode }}
            </div>

            <div
              class="font-heading-3 nordic-blue-900-text text-icon-primary bold-type ms-xxsmall-b font-headline-small"
            >
              {{ ondOffer.originCityName }} -
              {{ ondOffer.destinationCityName }}
            </div>

            <div class="light-type font-body-2 font-body-small">
              {{ ondOffer?.departureDate | finDateFormat: 'FULL' }} –
              {{ ondOffer?.returnDate | finDateFormat: 'FULL' }}
            </div>
          </div>

          <div class="flex-1 flex--basis0 flex--self-center flex--column align-right pr-medium-l">
            <div class="mr-xsmall-b">
              <div class="nordic-blue-900-text text-icon-primary light-type font-body-1 lowercase font-body-medium">
                {{ 'pricesStartingFrom' | finLocalization }}
              </div>

              <span
                class="heather-700-text text-icon-primary font-heading-2 bold-type inline-block animate-pulse font-headline-medium"
              >
                {{ ondOffer?.price | finPrice: { roundPrice: true } }}
              </span>
            </div>

            @if (ondOffer.link) {
              <button
                (click)="navigateToUrl(ondOffer)"
                class="offer-list-item__link bold-type font-body-1 nordic-blue-900-text text-icon-primary no-underline underline-hover font-body-medium-bold"
              >
                {{ 'bookNow' | finLocalization }}
                <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT" />
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (ondOffers().length > offerAmount()) {
  <div class="align-center">
    <button class="btn bold-type" (click)="loadMoreOffers()">{{ 'ondMarketing.loadMore' | finLocalization }}</button>
  </div>
}
